/**
 * 统一的动画配置
 * iOS风格的动画缓动函数和时长
 */

/**
 * iOS标准缓动函数
 * cubic-bezier(0.4, 0.0, 0.2, 1)
 */
export const IOS_EASING = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

/**
 * 标准动画时长（毫秒）
 */
export const ANIMATION_DURATION_MS = 300;

/**
 * 标准动画时长（秒）
 */
export const ANIMATION_DURATION_S = ANIMATION_DURATION_MS / 1000;

/**
 * 获取动画时长字符串（用于CSS）
 */
export const getAnimationDuration = (): string => {
  return `${ANIMATION_DURATION_S}s`;
};

/**
 * 获取完整的动画transition字符串
 */
export const getAnimationTransition = (properties: string = 'all'): string => {
  return `${properties} ${ANIMATION_DURATION_S}s ${IOS_EASING}`;
};
